/**
 * Line Style Enum
 *
 * Defines the visual line styles for lines and shape borders.
 *
 * @enum {string}
 */
export enum LineStyle {
  /**
   * Continuous solid line
   * Dash array: [1, 0]
   */
  Solid = 'Solid',

  /**
   * Dashed line pattern
   * Dash array: [4, 2]
   */
  Dashed = 'Dashed',

  /**
   * Dotted line pattern
   * Dash array: [1, 2]
   */
  Dotted = 'Dotted',
}
